export const HEADER = {
    FIRST_NAME: 'First name',
    LAST_NAME: 'Last name',
    RESOLUTION: 'Resolution',
    VISIT_DATE: 'Visit date',
    NEXT_VISIT: 'Next visit',
    ACTIONS: 'Actions',
}